<template>
  <div v-loading="loading">
    <div class="card card-custom card-stretch gutter-b response-answer">
      <div class="card-header">
        <div class="card-title">
          <span class="card-icon">
              <i class="flaticon2-delivery-package text-primary"></i>
          </span>
          <h3 class="card-label"><b class="title-header">履歴検索</b></h3>
        </div>
        <div>
          <ButtonSearchMobile></ButtonSearchMobile>
        </div>
      </div>
      <div class="card-body">
        <div id="search-form">
          <form @submit.prevent="onSubmit">
            <div class="row">
              <div class="col-md-9">
                <div class="row">
                  <div class="col-md-4 col-6">
                    <div class="form-group">
                      <label>フォーム名</label>
                      <input name="form_name" placeholder="フォーム名を入力" v-model="history.form_name" type="text" class="form-control"/>
                    </div>
                  </div>
                  <div class="col-md-4 col-6">
                    <div class="form-group">
                      <label>項目名キーワード</label>
                      <input name="label_name" placeholder="項目名キーワードを入力" v-model="history.label_name" type="text" class="form-control" />
                    </div>
                  </div>

                  <div class="col-md-4 col-6">
                      <div class="form-group">
                        <label class="d-block">フォームステータス</label>
                        <el-select class="w-100 bg-gray-item"
                                    v-model="history.form_status"
                                    multiple
                                    placeholder="選択してください">
                            <el-option
                                v-for="(item, index) in constants.FORM_BASE_STATUS"
                                :key="item.value"
                                :label="item.label"
                                :value="parseInt(item.value)">
                            </el-option>
                        </el-select>
                      </div>
                    </div>
                  <div class="col-6 text-right">
                    <div class="button-submit-mobile">
                      <button type="submit" @click="showFormSearch()" class="btn btn-primary mr-2">{{$t('search')}}</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group action-form-search">
                  <button type="submit" class="btn btn-primary mr-2">{{$t('search')}}</button>
                </div>
              </div>
            </div>
              <div class="row">
                  <div class="col-md-9">
                      <div class="row">
                          <div class="col-md-4 col-6">
                              <div class="form-group">
                                  <label>回答内容フリーワード</label>
                                  <input name="answer_content" placeholder="回答内容フリーワードを入力" v-model="history.answer_content" type="text" class="form-control" />
                              </div>
                          </div>
                          <div class="col-md-4 col-6">
                              <div class="form-group">
                                  <label>フォーム更新画面</label>
                                  <el-select class="w-100 bg-gray-item"
                                    v-model="history.model_type"
                                    multiple
                                    placeholder="選択してください">
                                      <el-option
                                          v-for="(item, index) in constants.MODEL_TYPE"
                                          :key="item.value"
                                          :label="item.label"
                                          :value="item.value">
                                      </el-option>
                                  </el-select>
                              </div>
                          </div>
                          <div class="col-md-4 col-6">
                              <div class="form-group">
                                  <label>回答者Key</label>
                                  <input name="user_email" placeholder="回答者Keyを入力" v-model="history.user_email" type="text" class="form-control" />
                              </div>
                          </div>
                          <div class="col-md-4 col-6">
                              <div class="form-group">
                                  <label>管理者Key</label>
                                  <input name="admin_email" placeholder="回答者Keyを入力" v-model="history.admin_email" type="text" class="form-control" />
                              </div>
                          </div>
                          <div class="col-md-4 col-6">
                              <div class="form-group">
                                  <label>回答ID</label>
                                  <input name="answer_id" placeholder="回答IDを入力" v-model="history.answer_id" type="text" class="form-control" />
                              </div>
                          </div>
                          
                      </div>
                  </div>
              </div>
          </form>
        </div>
        <div id="data-table-list">

          <div class="row float-right pr-5">
            <my-pagination
                v-if="historyList.total"
                :total-record="parseInt(historyList.total)"
                :current-page="parseInt(historyList.current_page)"
                :page-size-default="parseInt(historyList.per_page)"
                @handleCurrentChange="handleCurrentChange"
                @handleSizeChange="handleSizeChange"
            />
          </div>
          <el-table
              v-if="historyList.data && historyList.total > 0"
              class="mb-5 responsive-answer-table"
              :data="historyList.data"
              style="width: 100%;"
              @sort-change="sortChange"
          >
            <el-table-column
                prop="form_id"
                label="フォームID"
                sortable="false"
                class="table-column-custom"
                min-width="120"
            >
              <template slot-scope="scope">
                <span>
                  {{ scope.row.form_id }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
                prop="item_id"
                label="項目ID"
                sortable="false"
                class="table-column-custom"
                min-width="130"
            >
              <template slot-scope="scope">
                <span>
                  {{ scope.row.item_id }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
                prop="label_name"
                label="項目名"
                sortable="false"
                class="table-column-custom"
                min-width="210"
            >
            <template slot-scope="scope">
                <span v-if="scope.row.model_type !== 'form_answer' && scope.row.model_type !== 'form_answer_data' && scope.row.model_type !== 'form_base'">
                  {{ scope.row.label_name }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
                sortable="false"
                prop="answer_id"
                label="回答ID"
                class="table-column-custom"
                min-width="210"
            >
            </el-table-column>
            <el-table-column
                prop="user_email"
                label="回答者Key"
                sortable="false"
                class="table-column-custom"
                min-width="210"
            >
            </el-table-column>
            <el-table-column
                prop="old_values"
                label="変更前"
                sortable="false"
                class="table-column-custom"
                min-width="310"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.old_values && Object.keys(scope.row.old_values).length > 0">
                  <div class="old-values-form-base" v-if="scope.row.model_type_name == 'フォームベース'">
                    <p :class="{ 'field-changed': isFieldChanged('form_name', scope.row.old_values && scope.row.old_values.form_name, scope.row.new_values && scope.row.new_values.form_name, scope.row.action) }">
                      <span>フォーム名:</span> {{ scope.row.old_values && scope.row.old_values.form_name }}
                    </p>
                    <p :class="{ 'field-changed': isFieldChanged('form_url', scope.row.old_values && scope.row.old_values.form_url, scope.row.new_values && scope.row.new_values.form_url, scope.row.action) }">
                      <span>フォームURL:</span> 
                      {{ scope.row.old_values && scope.row.old_values.form_url }}
                    </p>
                    <p :class="{ 'field-changed': isFieldChanged('item_group_names', scope.row.old_values && scope.row.old_values.item_group_names, scope.row.new_values && scope.row.new_values.item_group_names, scope.row.action) }">
                      <span>項目グループ名:</span> 
                      {{ formatItemGroupNames(scope.row.old_values && scope.row.old_values.item_group_names) }}
                    </p>
                     <p :class="{ 'field-changed': isFieldChanged('item_group_name_middle', scope.row.old_values && scope.row.old_values.item_group_name_middle, scope.row.new_values && scope.row.new_values.item_group_name_middle, scope.row.action) }">
                      <span>項目グループ名（中）:</span> 
                      {{ formatItemGroupNameMiddle(scope.row.old_values && scope.row.old_values.item_group_name_middle) }}
                     </p>
                    <p :class="{ 'field-changed': isFieldChanged('form_status', scope.row.old_values && scope.row.old_values.form_status, scope.row.new_values && scope.row.new_values.form_status, scope.row.action) }">
                      <span>ステータス:</span> 
                      {{ parseInt(scope.row.old_values && scope.row.old_values.form_status) === constants.FORM_BASE_STATUS[0].value ? constants.FORM_BASE_STATUS[0].label : constants.FORM_BASE_STATUS[1].label }}
                    </p>
                      <p :class="{ 'field-changed': isFieldChanged('parent_form_name', scope.row.old_values && scope.row.old_values.parent_form_base && scope.row.old_values.parent_form_base.form_name, scope.row.new_values && scope.row.new_values.parent_form_base && scope.row.new_values.parent_form_base.form_name, scope.row.action) }">
                        <span>親フォーム名: </span>
                       {{ scope.row.old_values && scope.row.old_values.parent_form_base && scope.row.old_values.parent_form_base.form_name }}
                      </p>
                      <p :class="{ 'field-changed': isFieldChanged('tenant_name', scope.row.old_values && scope.row.old_values.tenant && scope.row.old_values.tenant.tenant_name, scope.row.new_values && scope.row.new_values.tenant && scope.row.new_values.tenant.tenant_name, scope.row.action) }">
                        <span>テナント: </span>
                       {{ scope.row.old_values && scope.row.old_values.tenant && scope.row.old_values.tenant.tenant_name }}
                      </p>
                      <p :class="{ 'field-changed': isFieldChanged('approval_name', scope.row.old_values && scope.row.old_values.approval && scope.row.old_values.approval.approval_name, scope.row.new_values && scope.row.new_values.approval && scope.row.new_values.approval.approval_name, scope.row.action) }">
                        <span>適用承認プロセス名: </span>
                        {{ scope.row.old_values && scope.row.old_values.approval && scope.row.old_values.approval.approval_name }}
                      </p>
                    <p :class="{ 'field-changed': isFieldChanged('display_new_account', scope.row.old_values && scope.row.old_values.display_new_account, scope.row.new_values && scope.row.new_values.display_new_account, scope.row.action) }">
                      <span>新規入力許可:</span> 
                      {{ parseInt(scope.row.old_values && scope.row.old_values.display_new_account) === 1  || (scope.row.old_values && scope.row.old_values.display_new_account === true) ? 'あり' : 'なし' }}
                    </p>
                    <p :class="{ 'field-changed': isFieldChanged('allow_login_form', scope.row.old_values && scope.row.old_values.allow_login_form, scope.row.new_values && scope.row.new_values.allow_login_form, scope.row.action) }">
                      <span>ログイン遷移許可:</span> 
                      {{ parseInt(scope.row.old_values && scope.row.old_values.allow_login_form) === 1  || (scope.row.old_values && scope.row.old_values.allow_login_form == true) ? 'あり' : 'なし' }}
                    </p>
                    <p :class="{ 'field-changed': isFieldChanged('allow_mypage_access', scope.row.old_values && scope.row.old_values.allow_mypage_access, scope.row.new_values && scope.row.new_values.allow_mypage_access, scope.row.action) }">
                      <span>マイページ遷移許可 :</span> 
                      {{ parseInt(scope.row.old_values && scope.row.old_values.allow_mypage_access) === 1  || (scope.row.old_values && scope.row.old_values.allow_mypage_access == true) ? 'あり' : 'なし' }}
                    </p>
                    <p :class="{ 'field-changed': isFieldChanged('copy_flag', scope.row.old_values && scope.row.old_values.copy_flag, scope.row.new_values && scope.row.new_values.copy_flag, scope.row.action) }">
                      <span>回答時に回答項目を親フォームからコピー  :</span> 
                      {{ parseInt(scope.row.old_values && scope.row.old_values.copy_flag) === 1  || (scope.row.old_values && scope.row.old_values.copy_flag == true) ? 'あり' : 'なし' }}
                    </p>
                    <p :class="{ 'field-changed': isFieldChanged('henshu_flg', scope.row.old_values && scope.row.old_values.henshu_flg, scope.row.new_values && scope.row.new_values.henshu_flg, scope.row.action) }">
                      <span>申請者が入力完了後にも情報修正を可能  :</span> 
                      {{ parseInt(scope.row.old_values && scope.row.old_values.henshu_flg) === 1  || (scope.row.old_values && scope.row.old_values.henshu_flg == true) ? 'あり' : 'なし' }}
                    </p>
                    <p :class="{ 'field-changed': isFieldChanged('copy_group_name', scope.row.old_values && scope.row.old_values.copy_group_name, scope.row.new_values && scope.row.new_values.copy_group_name, scope.row.action) }">
                      <span>回答時に項目グループ単位での解答欄複製を許可する  :</span> 
                      {{ parseInt(scope.row.old_values && scope.row.old_values.copy_group_name) === 1  || (scope.row.old_values && scope.row.old_values.copy_group_name == true) ? 'あり' : 'なし' }}
                    </p>
                    <p :class="{ 'field-changed': isCopyGroupNameMiddleChanged(scope.row.old_values, scope.row.new_values, scope.row.action) || (Array.isArray(scope.row.old_values) && scope.row.old_values.length === 0 )|| (scope.row.old_values === null ) }">
                      <span>回答時に項目グループ（中）単位での解答欄複製を許可する  :</span> 
                      ({{ parseInt(scope.row.old_values && scope.row.old_values.copy_group_name_middle) === 1  || (scope.row.old_values && scope.row.old_values.copy_group_name_middle == true) ? 'あり' : 'なし' }})
                      {{ formatItemGroupNameMiddle(scope.row.old_values && scope.row.old_values.item_group_name_middle_selected) }}
                    </p>
                     <p :class="{ 'field-changed': isFieldChanged('mail_flag', scope.row.old_values  && scope.row.old_values.mail_flag, scope.row.new_values  && scope.row.new_values.mail_flag, scope.row.action)|| (Array.isArray(scope.row.old_values) && scope.row.old_values.length === 0 )|| (scope.row.old_values === null ) }">
                       <span>親フォームの回答者に「子フォーム回答依頼メール」を発出: </span>
                       {{ parseInt(scope.row.old_values  && scope.row.old_values.mail_flag) === 1  || (scope.row.old_values  && scope.row.old_values.mail_flag == true) ? 'あり' : 'なし' }}
                     </p>
                     <p :class="{ 'field-changed': isFieldChanged('kaiso_flg', scope.row.old_values && scope.row.old_values.kaiso_flg, scope.row.new_values && scope.row.new_values.kaiso_flg, scope.row.action) }">
                       <span> 階層フォームとする: </span>
                       {{ parseInt(scope.row.old_values &&  scope.row.old_values.kaiso_flg) === 1  || (scope.row.old_values &&  scope.row.old_values.kaiso_flg == true) ? 'あり' : 'なし' }}
                     </p>
                     <p :class="{ 'field-changed': isFieldChanged('tenant_copy_flg', scope.row.old_values && scope.row.old_values.tenant_copy_flg, scope.row.new_values && scope.row.new_values.tenant_copy_flg, scope.row.action) }">
                       <span> 子テナントにコピーする: </span>
                       {{ parseInt(scope.row.old_values && scope.row.old_values.tenant_copy_flg) === 1  || (scope.row.old_values && scope.row.old_values.tenant_copy_flg == true) ? 'あり' : 'なし' }}
                     </p>
                     <p :class="{ 'field-changed': isFieldChanged('special_item', scope.row.old_values && scope.row.old_values.special_item, scope.row.new_values && scope.row.new_values.special_item, scope.row.action) }">
                       <span> 条件分岐・自動計算の機能: </span>
                       {{ parseInt(scope.row.old_values && scope.row.old_values.special_item) === 1  || (scope.row.old_values && scope.row.old_values.special_item == true) ? 'あり' : 'なし' }}
                     </p>
                  </div>
                  <div class="old_values-form-item" v-else-if="scope.row.model_type_name == 'フォーム項目定義'">
                    <p> <span>フォーム名:</span>{{scope.row.old_values && scope.row.old_values.form && scope.row.old_values.form.form_name}}</p>
                    <p :class="{ 'field-changed': isItemGroupNameChanged(scope.row.old_values, scope.row.new_values, scope.row.action) }">
                      <span >項目グループ名:</span> {{ getItemGroupNameByIndex(scope.row.old_values && scope.row.old_values.form && scope.row.old_values.form.item_group_names, scope.row.old_values && scope.row.old_values.item_group_name, scope.row.action) }}
                    </p>
                    <p :class="{ 'field-changed': isItemGroupNameMiddleChanged(scope.row.old_values, scope.row.new_values, scope.row.action) }">
                      <span >項目グループ名（中）:</span> {{ getItemGroupNameMiddleByIndex(scope.row.old_values && scope.row.old_values.form && scope.row.old_values.form.item_group_name_middle, scope.row.old_values && scope.row.old_values.item_group_name_middle, scope.row.action) }}
                    </p>
                    <p :class="{ 'field-changed': isFieldChanged('label_name', scope.row.old_values && scope.row.old_values.label_name, scope.row.new_values && scope.row.new_values.label_name, scope.row.action) }">
                      <span >ラベル名:</span> {{ scope.row.old_values && scope.row.old_values.label_name }}
                    </p>
                    <p :class="{ 'field-changed': isFieldChanged('input_method', scope.row.old_values && scope.row.old_values.input_method, scope.row.new_values && scope.row.new_values.input_method, scope.row.action) }">
                      <span >入力方式:</span> {{ getInputMethodLabel(scope.row.old_values && scope.row.old_values.input_method) }}
                    </p>
                    <p :class="{ 'field-changed': isFieldChanged('item_check_relation', scope.row.old_values && scope.row.old_values.item_check_relation, scope.row.new_values && scope.row.new_values.item_check_relation, scope.row.action) }">
                      <span >入力チェック:</span> {{ getCheckMethodLabelsFromRelation(scope.row.old_values && scope.row.old_values.item_check_relation) }}
                    </p>
                     <p :class="{ 'field-changed': isFieldChanged('display_order', scope.row.old_values && scope.row.old_values.display_order, scope.row.new_values && scope.row.new_values.display_order, scope.row.action) }">
                       <span >表示順:</span> {{ scope.row.old_values && scope.row.old_values.display_order }}
                     </p>
                     <p :class="{ 'field-changed': isFieldChanged('special_processing', scope.row.old_values && scope.row.old_values.special_processing, scope.row.new_values && scope.row.new_values.special_processing, scope.row.action) }">
                       <span >特殊処理:</span> 
                       {{ getSpecialProcessingLabel(scope.row.old_values && scope.row.old_values.special_processing) }}
                     </p>
                     <p :class="{ 'field-changed': isFieldChanged('item_role', scope.row.old_values && scope.row.old_values.item_role, scope.row.new_values && scope.row.new_values.item_role, scope.row.action) }">
                       <span >項目権限:</span> 
                       {{ getItemRoleLabel(scope.row.old_values && scope.row.old_values.item_role) }}
                     </p>
                     
                  </div>

                </div>
              </template>
            </el-table-column>
            <el-table-column
                prop="new_values"
                label="変更後"
                sortable="false"
                class="table-column-custom"
                min-width="310"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.new_values && Object.keys(scope.row.new_values).length > 0">
                  <div class="new-values-form-base" v-if="scope.row.model_type_name == 'フォームベース'">
                    <p :class="{ 'field-changed': 
                     (isFieldChanged('form_name', scope.row.old_values && scope.row.old_values.form_name, scope.row.new_values && scope.row.new_values.form_name, scope.row.action) )}">
                      <span>フォーム名: </span> {{ scope.row.new_values && scope.row.new_values.form_name }}
                    </p>
                    <p :class="{ 'field-changed': 
                    (isFieldChanged('form_url', scope.row.old_values && scope.row.old_values.form_url, scope.row.new_values && scope.row.new_values.form_url, scope.row.action) )}">
                      <span>フォームURL:</span> 
                      {{ scope.row.new_values && scope.row.new_values.form_url }}
                    </p>
                    <p :class="{ 'field-changed': 
                      (isFieldChanged('item_group_names', scope.row.old_values && scope.row.old_values.item_group_names, scope.row.new_values && scope.row.new_values.item_group_names, scope.row.action) ) || ( Array.isArray(scope.row.old_values) && scope.row.old_values.length === 0) || (scope.row.old_values === null) }">
                      <span>項目グループ名:</span> 
                      {{ formatItemGroupNames(scope.row.new_values && scope.row.new_values.item_group_names) }}
                    </p>
                     <p :class="{ 'field-changed': 
                     (isFieldChanged('item_group_name_middle', scope.row.old_values && scope.row.old_values.item_group_name_middle, scope.row.new_values && scope.row.new_values.item_group_name_middle, scope.row.action) ) || ( Array.isArray(scope.row.old_values) && scope.row.old_values.length === 0) || (scope.row.old_values === null) }">
                      <span>項目グループ名（中）:</span> 
                      {{ formatItemGroupNameMiddle(scope.row.new_values && scope.row.new_values.item_group_name_middle) }}
                     </p>
                    <p :class="{ 'field-changed': 
                    (isFieldChanged('form_status', scope.row.old_values && scope.row.old_values.form_status, scope.row.new_values && scope.row.new_values.form_status, scope.row.action) )|| ( Array.isArray(scope.row.old_values) && scope.row.old_values.length === 0) || (scope.row.old_values === null) } ">
                      <span>ステータス:</span> 
                      {{ parseInt(scope.row.new_values && scope.row.new_values.form_status) === constants.FORM_BASE_STATUS[0].value ? constants.FORM_BASE_STATUS[0].label : constants.FORM_BASE_STATUS[1].label }}
                    </p>
                      <p :class="{ 'field-changed': 
                      (isFieldChanged('parent_form_name', scope.row.old_values && scope.row.old_values.parent_form_base && scope.row.old_values.parent_form_base.form_name, scope.row.new_values && scope.row.new_values.parent_form_base && scope.row.new_values.parent_form_base.form_name, scope.row.action) )|| ( Array.isArray(scope.row.old_values) && scope.row.old_values.length === 0) ||(scope.row.old_values === null)}">
                        <span>親フォーム名: </span>
                       {{ scope.row.new_values && scope.row.new_values.parent_form_base && scope.row.new_values.parent_form_base.form_name }}
                      </p>
                      <p :class="{ 'field-changed': 
                      (isFieldChanged('tenant_name', scope.row.old_values && scope.row.old_values.tenant && scope.row.old_values.tenant.tenant_name, scope.row.new_values && scope.row.new_values.tenant && scope.row.new_values.tenant.tenant_name, scope.row.action) )|| ( Array.isArray(scope.row.old_values) && scope.row.old_values.length === 0) ||(scope.row.old_values === null)}">
                        <span>テナント: </span>
                       {{ scope.row.new_values && scope.row.new_values.tenant && scope.row.new_values.tenant.tenant_name }}
                      </p>
                      <p :class="{ 
                        'field-changed': isFieldChanged(
                          'approval_name',
                          scope.row.old_values && scope.row.old_values.approval && scope.row.old_values.approval.approval_name,
                          scope.row.new_values && scope.row.new_values.approval && scope.row.new_values.approval.approval_name,
                          scope.row.action
                        ) || (Array.isArray(scope.row.old_values) && scope.row.old_values.length === 0 )|| (scope.row.old_values === null )
                      }">
                        <span>適用承認プロセス名: </span>
                        {{ scope.row.new_values && scope.row.new_values.approval && scope.row.new_values.approval.approval_name }}
                      </p>
                    <p :class="{ 'field-changed': 
                    (isFieldChanged('display_new_account', scope.row.old_values && scope.row.old_values.display_new_account, scope.row.new_values && scope.row.new_values.display_new_account, scope.row.action) )}">
                      <span>新規入力許可:</span> 
                      {{ parseInt(scope.row.new_values && scope.row.new_values.display_new_account) === 1  || (scope.row.new_values && scope.row.new_values.display_new_account === true) ? 'あり' : 'なし' }}
                    </p>
                    <p :class="{ 'field-changed': 
                    (isFieldChanged('allow_login_form', scope.row.old_values && scope.row.old_values.allow_login_form, scope.row.new_values && scope.row.new_values.allow_login_form, scope.row.action) )}">
                      <span>ログイン遷移許可:</span> 
                      {{ parseInt(scope.row.new_values && scope.row.new_values.allow_login_form) === 1  || (scope.row.new_values && scope.row.new_values.allow_login_form == true) ? 'あり' : 'なし' }}
                    </p>
                    <p :class="{ 'field-changed': 
                    (isFieldChanged('allow_mypage_access', scope.row.old_values && scope.row.old_values.allow_mypage_access, scope.row.new_values && scope.row.new_values.allow_mypage_access, scope.row.action) )}">
                      <span>マイページ遷移許可 :</span> 
                      {{ parseInt(scope.row.new_values && scope.row.new_values.allow_mypage_access) === 1  || (scope.row.new_values && scope.row.new_values.allow_mypage_access == true) ? 'あり' : 'なし' }}
                    </p>
                    <p :class="{ 'field-changed': 
                    (isFieldChanged('copy_flag', scope.row.old_values && scope.row.old_values.copy_flag, scope.row.new_values && scope.row.new_values.copy_flag, scope.row.action) )}">
                      <span>回答時に回答項目を親フォームからコピー  :</span> 
                      {{ parseInt(scope.row.new_values && scope.row.new_values.copy_flag) === 1  || (scope.row.new_values && scope.row.new_values.copy_flag == true) ? 'あり' : 'なし' }}
                    </p>
                    <p :class="{ 'field-changed': 
                    (isFieldChanged('henshu_flg', scope.row.old_values && scope.row.old_values.henshu_flg, scope.row.new_values && scope.row.new_values.henshu_flg, scope.row.action) )}">
                      <span>申請者が入力完了後にも情報修正を可能  :</span> 
                      {{ parseInt(scope.row.new_values && scope.row.new_values.henshu_flg) === 1  || (scope.row.new_values && scope.row.new_values.henshu_flg == true) ? 'あり' : 'なし' }}
                    </p>
                    <p :class="{ 'field-changed': 
                    (isFieldChanged('copy_group_name', scope.row.old_values && scope.row.old_values.copy_group_name, scope.row.new_values && scope.row.new_values.copy_group_name, scope.row.action) )}">
                      <span>回答時に項目グループ単位での解答欄複製を許可する  :</span> 
                      {{ parseInt(scope.row.new_values && scope.row.new_values.copy_group_name) === 1  || (scope.row.new_values && scope.row.new_values.copy_group_name == true) ? 'あり' : 'なし' }}
                    </p>
                    <p :class="{ 'field-changed': 
                    (isCopyGroupNameMiddleChanged(scope.row.old_values, scope.row.new_values, scope.row.action) )|| (Array.isArray(scope.row.old_values) && scope.row.old_values.length === 0 )|| (scope.row.old_values === null )}">
                      <span>回答時に項目グループ（中）単位での解答欄複製を許可する  :</span> 
                      ({{ parseInt(scope.row.new_values && scope.row.new_values.copy_group_name_middle) === 1  || (scope.row.new_values && scope.row.new_values.copy_group_name_middle == true) ? 'あり' : 'なし' }})
                      {{ formatItemGroupNameMiddle(scope.row.new_values && scope.row.new_values.item_group_name_middle_selected) }}
                    </p>
                     <p :class="{ 'field-changed':
                      (isFieldChanged('mail_flag', scope.row.old_values &&  scope.row.old_values.mail_flag, scope.row.new_values  && scope.row.new_values.mail_flag, scope.row.action) )|| (Array.isArray(scope.row.old_values) && scope.row.old_values.length === 0 )|| (scope.row.old_values === null ) }">
                       <span>親フォームの回答者に「子フォーム回答依頼メール」を発出: </span>
                       {{ parseInt(scope.row.new_values &&  scope.row.new_values.mail_flag) === 1  || (scope.row.new_values && scope.row.new_values.mail_flag == true) ? 'あり' : 'なし' }}
                     </p>
                     <p :class="{ 'field-changed': 
                     (isFieldChanged('kaiso_flg', scope.row.old_values &&  scope.row.old_values.kaiso_flg, scope.row.new_values &&  scope.row.new_values.kaiso_flg, scope.row.action) )}">
                       <span> 階層フォームとする: </span>
                       {{ parseInt(scope.row.new_values && scope.row.new_values.kaiso_flg) === 1  || (scope.row.new_values  && scope.row.new_values.kaiso_flg == true) ? 'あり' : 'なし' }}
                     </p>
                     <p :class="{ 'field-changed': 
                     (isFieldChanged('tenant_copy_flg', scope.row.old_values && scope.row.old_values.tenant_copy_flg, scope.row.new_values && scope.row.new_values.tenant_copy_flg, scope.row.action) )}">
                       <span> 子テナントにコピーする: </span>
                       {{ parseInt(scope.row.new_values && scope.row.new_values.tenant_copy_flg) === 1  || (scope.row.new_values && scope.row.new_values.tenant_copy_flg == true) ? 'あり' : 'なし' }}
                     </p>
                     <p :class="{ 'field-changed': 
                     (isFieldChanged('special_item', scope.row.old_values && scope.row.old_values.special_item, scope.row.new_values && scope.row.new_values.special_item, scope.row.action) )}">
                       <span> 条件分岐・自動計算の機能: </span>
                       {{ parseInt(scope.row.new_values && scope.row.new_values.special_item) === 1  || (scope.row.new_values && scope.row.new_values.special_item == true) ? 'あり' : 'なし' }}
                     </p>
                  </div>
                  <div class="new_values-form-item" v-else-if="scope.row.model_type_name == 'フォーム項目定義'">
                       <p :class="{'field-changed': (Array.isArray(scope.row.old_values) && scope.row.old_values.length === 0 )|| (scope.row.old_values === null )}"> 
                         <span>フォーム名: </span>{{scope.row.new_values && scope.row.new_values.form && scope.row.new_values.form.form_name}}
                      </p>
                       <p :class="{ 'field-changed': 
                       (isItemGroupNameChanged(scope.row.old_values, scope.row.new_values, scope.row.action) )}">
                         <span >項目グループ名:</span> {{ getItemGroupNameByIndex(scope.row.new_values && scope.row.new_values.form && scope.row.new_values.form.item_group_names, scope.row.new_values && scope.row.new_values.item_group_name) }}
                       </p>
                       <p :class="{ 'field-changed': 
                       (isItemGroupNameMiddleChanged(scope.row.old_values, scope.row.new_values, scope.row.action) )}">
                         <span >項目グループ名（中）:</span> {{ getItemGroupNameMiddleByIndex(scope.row.new_values && scope.row.new_values.form && scope.row.new_values.form.item_group_name_middle, scope.row.new_values && scope.row.new_values.item_group_name_middle) }}
                       </p>
                       <p :class="{ 'field-changed': 
                       (isFieldChanged('label_name', scope.row.old_values && scope.row.old_values.label_name, scope.row.new_values && scope.row.new_values.label_name, scope.row.action) )}">
                         <span >ラベル名:</span> {{ scope.row.new_values && scope.row.new_values.label_name }}
                       </p>
                       <p :class="{ 'field-changed': 
                       (isFieldChanged('input_method', scope.row.old_values && scope.row.old_values.input_method, scope.row.new_values && scope.row.new_values.input_method, scope.row.action) )}">
                         <span >入力方式:</span> {{ getInputMethodLabel(scope.row.new_values && scope.row.new_values.input_method) }}
                       </p>
                       <p :class="{ 'field-changed': 
                       (isFieldChanged('item_check_relation', scope.row.old_values && scope.row.old_values.item_check_relation, scope.row.new_values && scope.row.new_values.item_check_relation, scope.row.action) )|| ( Array.isArray(scope.row.old_values) && scope.row.old_values.length === 0) || (scope.row.old_values === null)}">
                         <span >入力チェック:</span> {{ getCheckMethodLabelsFromRelation(scope.row.new_values && scope.row.new_values.item_check_relation) }}
                       </p>
                       <p :class="{ 'field-changed': 
                       (isFieldChanged('display_order', scope.row.old_values && scope.row.old_values.display_order, scope.row.new_values && scope.row.new_values.display_order, scope.row.action) )}">
                         <span >表示順:</span> {{ scope.row.new_values && scope.row.new_values.display_order }}
                       </p>
                       <p :class="{ 'field-changed': 
                       (isFieldChanged('special_processing', scope.row.old_values && scope.row.old_values.special_processing, scope.row.new_values && scope.row.new_values.special_processing, scope.row.action) )|| ( Array.isArray(scope.row.old_values) && scope.row.old_values.length === 0) || (scope.row.old_values === null) }">
                         <span >特殊処理:</span> 
                         {{ getSpecialProcessingLabel(scope.row.new_values && scope.row.new_values.special_processing) }}
                       </p>
                       <p :class="{ 'field-changed': 
                       (isFieldChanged('item_role', scope.row.old_values && scope.row.old_values.item_role, scope.row.new_values && scope.row.new_values.item_role, scope.row.action) )}">
                         <span >項目権限:</span> 
                         {{ getItemRoleLabel(scope.row.new_values && scope.row.new_values.item_role) }}
                       </p>
                    </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
                sortable="false"
                prop="model_type_name"
                label="タイプ"
                min-width="200">
            </el-table-column>
            <el-table-column
                sortable="false"
                prop="action"
                label="アクション"
                min-width="200"
            >
              <template slot-scope="scope">
                <span>{{ getActionTypeLabel(scope.row.action) }}</span>
              </template>
            </el-table-column>
            <el-table-column
                sortable="false"
                prop="admin_id"
                label="管理者ID"
                min-width="200"
            >
            </el-table-column>
            <el-table-column
                sortable="false"
                prop="admin_email"
                label="管理者Key"
                min-width="200"
            >
            </el-table-column>
            <el-table-column
              sortable="false"
              prop="created_at"
              label="日付"
              min-width="200"
            >
              <template slot-scope="scope">
                <span>{{ formatDateTime(scope.row.updated_at) }}</span>
              </template>
            </el-table-column>
          </el-table>
          <div v-else class="text-center no-list-data">{{$t('el.table.emptyText')}}</div>

          <div class="row float-right pr-5">
            <my-pagination
                v-if="historyList.total"
                :total-record="parseInt(historyList.total)"
                :current-page="parseInt(historyList.current_page)"
                :page-size-default="parseInt(historyList.per_page)"
                @handleCurrentChange="handleCurrentChange"
                @handleSizeChange="handleSizeChange"
            />
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import mixinSearch from "@/mixins/searchMixin";
import * as constants from "@/core/config/constant";
import {mapActions, mapGetters, mapMutations} from "vuex";

import {
GET_HISTORY_LIST,
} from "@/core/services/store/history.module";
import ButtonSearchMobile from "@/view/components/ButtonSearchMobile";
import { history } from "../../../core/services/apis/history";

export default {
name: "list",
components: {ButtonSearchMobile},
mixins: [mixinSearch],
data() {
  return {
    loading:false,
    history:{
      form_name:'',
      label_name:'',
      form_status:[],
      answer_content: '',
      model_type: [],
      user_email: '',
      admin_email :'' ,
      answer_id: '',
    },
    constants: constants
  }
},
computed: {
  ...mapGetters([
    'historyList'
  ]),
  queryParam() {
    return this.$route.query
  },
},
watch: {
  async queryParam() {
    this.loading = true;
      if (Object.keys(this.queryParam).length === 0){
          this.resetDataSearch();
      }
    await this.getHistoryList(this.queryParam);
    this.getDataFromQuery();
    this.loading = false;
  }
},
async created() {
  this.loading = true;
  this.getDataFromQuery();
  await this.getHistoryList(this.queryParam);
  this.loading = false;
},
methods: {
  ...mapActions([GET_HISTORY_LIST]),
  
  // Method to check if copy_group_name_middle field has changed (considering both copy_group_name_middle and item_group_name_middle_selected)
  isCopyGroupNameMiddleChanged(oldValues, newValues, action) {
    if (action === 'deleted') {
      return false;
    }
    
    // Check if copy_group_name_middle value changed
    const oldCopyGroupNameMiddle = oldValues && oldValues.copy_group_name_middle;
    const newCopyGroupNameMiddle = newValues && newValues.copy_group_name_middle;
    
    // Check if item_group_name_middle_selected value changed
    const oldItemGroupNameMiddleSelected = oldValues && oldValues.item_group_name_middle_selected;
    const newItemGroupNameMiddleSelected = newValues && newValues.item_group_name_middle_selected;
    
    // If copy_group_name_middle changed from 0 to 1 or vice versa
    const copyGroupNameMiddleChanged = oldCopyGroupNameMiddle !== newCopyGroupNameMiddle;
    
    // If item_group_name_middle_selected changed
    const itemGroupNameMiddleSelectedChanged = this.isFieldChanged('item_group_name_middle_selected', oldItemGroupNameMiddleSelected, newItemGroupNameMiddleSelected, action);
    
    // Return true if either condition is true
    return copyGroupNameMiddleChanged || itemGroupNameMiddleSelectedChanged;
  },
  sortChange(sortProps){
    this.sortColumn('history',sortProps);
  },
  getDataFromQuery(){
    this.history.form_name = this.queryParam.form_name ? this.queryParam.form_name : '';
    this.history.label_name = this.queryParam.label_name ? this.queryParam.label_name : '';
    this.history.answer_content = this.queryParam.answer_content ? this.queryParam.answer_content : '';
    this.history.user_email = this.queryParam.user_email ? this.queryParam.user_email : '';
    this.history.admin_email = this.queryParam.admin_email ? this.queryParam.admin_email : '';
    this.history.answer_id = this.queryParam.answer_id ? this.queryParam.answer_id : '';
    
    // Xử lý form_status
    let formStatus = (this.queryParam.form_status && this.queryParam.form_status.length ) ? this.queryParam.form_status.split(',') : [];
    this.history.form_status = formStatus.map(item => parseInt(item));
    
    // Xử lý model_type
    let modelType = (this.queryParam.model_type && this.queryParam.model_type.length ) ? this.queryParam.model_type.split(',') : [];
    this.history.model_type = modelType;
  },
  onSubmit(){
    this.history.form_name = this.history.form_name.trim()
    this.history.label_name = this.history.label_name.trim()
    this.history.answer_content = this.history.answer_content.trim()
    this.history.user_email = this.history.user_email.trim()
    this.history.admin_email = this.history.admin_email.trim()
    this.history.answer_id = this.history.answer_id.trim()
    this.getDataSearch(this.history);
    this.search("history")
  },
  handleSizeChange(val) {
    this.sizeChange('history',val);
  },
  handleCurrentChange(val) {
    this.pageChange('history',val);
  },
  formatDateTime(dateTime) {
    if (!dateTime) return '';
    const date = new Date(dateTime);
    const year = date.getFullYear().toString();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  },
   formatItemGroupNameMiddle(itemGroupNameMiddle) {
     if (!itemGroupNameMiddle || itemGroupNameMiddle === 'undefined' || itemGroupNameMiddle === 'null') return '';
     try {
       const parsed = JSON.parse(itemGroupNameMiddle);
       if (parsed && typeof parsed === 'object') {
         return Object.values(parsed).map(value => value.trim()).join(', ');
       }else {
         return itemGroupNameMiddle;
       }
     } catch (error) {
       console.warn('Error parsing item_group_name_middle:', error);
       return itemGroupNameMiddle;
     }
   },
  
   formatItemGroupNames(itemGroupNames) {
     if (!itemGroupNames || itemGroupNames === 'undefined' || itemGroupNames === 'null') return '';
     try {
       const parsed = JSON.parse(itemGroupNames);
       if (parsed && typeof parsed === 'object') {
         return Object.values(parsed).map(value => value.trim()).join(', ');
       }
       return itemGroupNames;
     } catch (error) {
       console.warn('Error parsing item_group_names:', error);
       return itemGroupNames;
     }
   },
   
   // Method to get item group name by index (only used for フォーム項目定義)
   getItemGroupNameByIndex(itemGroupNames, index) {
     if (!itemGroupNames || !index || itemGroupNames === 'null' || itemGroupNames === 'undefined') return '';
     try {
       const parsed = JSON.parse(itemGroupNames);
       if (parsed && typeof parsed === 'object') {
         return parsed[index] || '';
       }
       return '';
     } catch (error) {
       console.warn('Error parsing item_group_names for index:', error);
       return '';
     }
   },
   
   // Method to check item_group_name changes with context from form (only used for フォーム項目定義)
   isItemGroupNameChanged(oldValues, newValues, action) {
     // If action is "deleted", don't highlight
     if (action === 'deleted') {
       return false;
     }
     // If old_values is null, consider it as a change
      if (!oldValues || (Array.isArray(oldValues) && oldValues.length === 0)) {
        return true;
      }
     const oldGroupName = this.getItemGroupNameByIndex(oldValues?.form?.item_group_names, oldValues?.item_group_name);
     const newGroupName = this.getItemGroupNameByIndex(newValues?.form?.item_group_names, newValues?.item_group_name);
     return oldGroupName !== newGroupName;
   },
   
   // Method to get item group name middle by index (only used for フォーム項目定義)
   getItemGroupNameMiddleByIndex(itemGroupNameMiddle, index) {
     if (!itemGroupNameMiddle || !index || itemGroupNameMiddle === 'null' || itemGroupNameMiddle === 'undefined') return '';
     try {
       const parsed = JSON.parse(itemGroupNameMiddle);
       if (parsed && typeof parsed === 'object') {
         return parsed[index] || '';
       }
       return '';
     } catch (error) {
       console.warn('Error parsing item_group_name_middle for index:', error);
       return '';
     }
   },
   
   // Method to check item_group_name_middle changes with context from form (only used for フォーム項目定義)
   isItemGroupNameMiddleChanged(oldValues, newValues, action) {
     // If action is "deleted", don't highlight
     if (action === 'deleted') {
       return false;
     }
     // If old_values is null, consider it as a change
      if (!oldValues || (Array.isArray(oldValues) && oldValues.length === 0)) {
        return true;
      }
     const oldGroupNameMiddle = this.getItemGroupNameMiddleByIndex(oldValues?.form?.item_group_name_middle, oldValues?.item_group_name_middle);
     const newGroupNameMiddle = this.getItemGroupNameMiddleByIndex(newValues?.form?.item_group_name_middle, newValues?.item_group_name_middle);
     return oldGroupNameMiddle !== newGroupNameMiddle;
   },
  getInputMethodLabel(inputMethodValue) {
    if (!inputMethodValue) return '';
    const inputMethod = constants.INPUT_METHOD.find(item => item.value === inputMethodValue);
    return inputMethod ? inputMethod.label : '';
  },
  getSpecialProcessingLabel(specialProcessingValue) {
    if (!specialProcessingValue) return '';
    const specialProcessing = constants.SPECIAL_PROCESSING.find(item => item.value === specialProcessingValue);
    return specialProcessing ? specialProcessing.label : '';
  },
  getItemRoleLabel(itemRoleValue) {
    if (!itemRoleValue) return '';
    const itemRole = constants.ITEM_ROLE.find(item => item.value === itemRoleValue);
    return itemRole ? itemRole.label : '';
  },
  getCheckMethodLabels(checkMethodArray) {
    if (!checkMethodArray || !Array.isArray(checkMethodArray)) return '';
    return checkMethodArray.map(value => {
      const checkMethod = constants.CHECK_METHOD.find(item => item.value === value);
      return checkMethod ? checkMethod.label : '';
    }).filter(label => label !== '').join(', ');
  },
  getCheckMethodLabelsFromRelation(itemCheckRelation) {
    if (!itemCheckRelation || !Array.isArray(itemCheckRelation)) return '';
    return itemCheckRelation.map(relation => {
      const checkMethod = constants.CHECK_METHOD.find(item => item.value === relation.check_method);
      return checkMethod ? checkMethod.label : '';
    }).filter(label => label !== '').join(', ');
  },
  getActionTypeLabel(actionTypeValue) {
    if (!actionTypeValue) return '';
    const actionType = constants.ACTION_TYPE.find(item => item.value === actionTypeValue);
    return actionType ? actionType.label : '';
  },
  isFieldChanged(fieldName, oldValue, newValue, action) {
    // Nếu action là "deleted" thì không cần check bôi đỏ
    if (action === 'deleted') {
      return false;
    }
    
    const getDisplayValue = (value) => {
      if (value === null || value === undefined) return '';
      
      // Handle boolean fields that return asynchronous values
      if (['display_new_account', 'allow_login_form', 'allow_mypage_access', 'copy_flag', 'henshu_flg', 'copy_group_name', 'copy_group_name_middle', 'mail_flag', 'kaiso_flg', 'tenant_copy_flg', 'special_item'].includes(fieldName)) {
        const boolValue = parseInt(value) === 1 || value === true || value === '1';
        return boolValue ? 'あり' : 'なし';
      }
      
      // Handle form_status field
      if (fieldName === 'form_status') {
        const statusValue = parseInt(value);
        return statusValue === constants.FORM_BASE_STATUS[0].value ? constants.FORM_BASE_STATUS[0].label : constants.FORM_BASE_STATUS[1].label;
      }
      
      // Handle input_method field
      if (fieldName === 'input_method') {
        return this.getInputMethodLabel(value);
      }
      
      // Handle special_processing field
      if (fieldName === 'special_processing') {
        return this.getSpecialProcessingLabel(value);
      }
      
      // Handle item_role field
      if (fieldName === 'item_role') {
        return this.getItemRoleLabel(value);
      }
      
      // Handle item_group_names field
      if (fieldName === 'item_group_names') {
        return this.formatItemGroupNames(value);
      }
      
      // Handle item_group_name_middle field
      if (fieldName === 'item_group_name_middle') {
        return this.formatItemGroupNameMiddle(value);
      }
      
      // Handle item_group_name_middle_selected field
      if (fieldName === 'item_group_name_middle_selected') {
        return this.formatItemGroupNameMiddle(value);
      }
      
      // Handle form_item_check field (array)
      if (fieldName === 'form_item_check') {
        return this.getCheckMethodLabels(value);
      }
      
      // Handle item_check_relation field (array of objects)
      if (fieldName === 'item_check_relation') {
        return this.getCheckMethodLabelsFromRelation(value);
      }
      
      // Other fields
      return String(value);
    };
    
    const oldDisplayValue = getDisplayValue(oldValue);
    const newDisplayValue = getDisplayValue(newValue);
    
    // Special case for form_item_check: if oldValue is null or empty array, consider it as a change
    if (fieldName === 'form_item_check') {
     const oldIsEmpty = !oldValue || (Array.isArray(oldValue) && oldValue.length === 0);
     const newHasValue = Array.isArray(newValue) && newValue.length > 0;

     // Case 1: oldValue rỗng/null/không tồn tại → new có giá trị
     if (oldIsEmpty && newHasValue) return true;

     // Case 2: old có giá trị → new rỗng/null (xóa hết check)
     if (!oldIsEmpty && (!newValue || (Array.isArray(newValue) && newValue.length === 0))) return true;
   }
   
   // Special case for item_check_relation: if oldValue is null or empty array, consider it as a change
   if (fieldName === 'item_check_relation') {
     const oldIsEmpty = !oldValue || (Array.isArray(oldValue) && oldValue.length === 0);
     const newHasValue = Array.isArray(newValue) && newValue.length > 0;

     // Case 1: oldValue rỗng/null/không tồn tại → new có giá trị
     if (oldIsEmpty && newHasValue) return true;

     // Case 2: old có giá trị → new rỗng/null (xóa hết check)
     if (!oldIsEmpty && (!newValue || (Array.isArray(newValue) && newValue.length === 0))) return true;
     
     // Case 3: So sánh chi tiết các check_method
     if (oldValue && newValue && Array.isArray(oldValue) && Array.isArray(newValue)) {
       const oldCheckMethods = oldValue.map(item => item.check_method).sort();
       const newCheckMethods = newValue.map(item => item.check_method).sort();
       
       // So sánh mảng check_method
       if (oldCheckMethods.length !== newCheckMethods.length) return true;
       for (let i = 0; i < oldCheckMethods.length; i++) {
         if (oldCheckMethods[i] !== newCheckMethods[i]) return true;
       }
     }
   }
    return oldDisplayValue !== newDisplayValue;
  }
},

}
</script>
<style scoped lang="scss">
.old-values-form-base, .new-values-form-base, .new_values-form-item, .old_values-form-item {
  p > span {
    font-weight: bold;
  }
  
  .field-changed {
    background-color: #ffebee !important;
    color: #d32f2f !important;
    padding: 4px 8px;
    border-radius: 4px;
    border-left: 3px solid #d32f2f;
    
    span {
      color: #d32f2f !important;
      font-weight: bold;
    }
  }
}
</style>